module.exports = __webpack_public_path__ + "img/5-1.38edd385.png";